export default {
  "bank-icon-container": "_bank-icon-container_1jcwmk",
  "background-icon": "_background-icon_1jcwmk"
};
